import { actions } from '../constants/announcement';
import * as actionTypes from '../../models/action/announcement';
import { ILoginAnnouncementByIdModel } from '../../models/pages/announcement';
import { IAction } from '../../models/action/core';

export function addAnnouncementGetAction(announcementData: actionTypes.IAnnouncement, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: any) => void): actionTypes.IGetAddAnnouncement {
    return {
        announcementData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_ANNOUNCEMENT,
        callback
    };
}
 
export function getAnnouncementsAction(gStateId: string, spinnerId?: string, spinnerType?: 'get'|'set', take?: number, skip?: number, callback?: any, searchedWord?: string, isHomePageAnnouncement?: boolean, isShowOnStartup?: boolean, lastAnnouncementId?: string,isHompageBox?: boolean): actionTypes.IAnnouncementsGetAction {
    return {
        timestamp: Date.now(),
        spinnerId,
        spinnerType,
        stateId: gStateId,
        take,
        skip,
        type: actions.GET_ANNOUNCEMENT_LIST,
        callback,
        searchedWord,
        isHomePageAnnouncement,
        isShowOnStartup,
        lastAnnouncementId,
        isHompageBox
    };
}

export function setAnnouncementsAction(
    announcements: actionTypes.IAnnouncement[],
    announcementIsLoaded: boolean,
    stateId: string, spinnerId?: string, spinnerType?: 'get'|'set',
    take?: number,
    skip?: number,
    isHomePageAnnouncement?: boolean,
    lastAnnouncementId?: string
): actionTypes.IAnnouncementsSetAction {
    return {
        announcementIsLoaded,
        spinnerId,
        spinnerType,
        announcements,
        stateId,
        timestamp: Date.now(),
        type: actions.SET_ANNOUNCEMENT_LIST,
        take,
        skip,
        isHomePageAnnouncement,
        lastAnnouncementId
    };
}


export function getSelectedAnnouncementAction(announcementId: string, spinnerId?: string, spinnerType?: 'get' | 'set', announcementIndex?: number, callback?: any): actionTypes.ISelectedAnnouncementGetAction {
    return {
        spinnerId,
        spinnerType,
        announcementId,
        timestamp: Date.now(),
        type: actions.GET_SELECTED_ANNOUNCEMENT,
        announcementIndex,
        callback
    };
}

export function setSelectedAnnouncementAction(
    selectedAnnouncement: ILoginAnnouncementByIdModel | null,
    selectedAnnouncementIsLoaded: boolean,
    spinnerId?: string, spinnerType?: 'get' | 'set',announcementIndex?: number
): actionTypes.ISelectedAnnouncementSetAction {
    return {
        selectedAnnouncement,
        selectedAnnouncementIsLoaded,
        timestamp: Date.now(),
        type: actions.SET_SELECTED_ANNOUNCEMENT,
        spinnerId,
        spinnerType,
        announcementIndex
    };
}

export function getAnnouncementData(announcementId: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: any): actionTypes.IGetAnnouncementActionParams {
    return {
        announcementId,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        callback,
        type: actions.GET_ANNOUNCEMENT_DATA
    };
}

export function setAnnouncementData(announcementData: ILoginAnnouncementByIdModel | null, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ISetAnnouncementActionParams {
    return {
        announcementData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_ANNOUNCEMENT_DATA
    };
}

export function setAnnouncementDataDefault(spinnerId?: string, spinnerType?: 'get' | 'set'): IAction {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_ANNOUNCEMENT_DATA_DEFAULT
    };
}

export function setSelectedAnnouncementDataDefault(spinnerId?: string, spinnerType?: 'get' | 'set', callback?: any): IAction {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_SELECTED_ANNOUNCEMENT_DATA_DEFAULT,
        callback
    };
}

export function getDeleteAnnouncement(
    announcementData: actionTypes.IDeleteAnnouncementData,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    callback?: any
): actionTypes.IGetDeleteAnnouncement {
    return {
        announcementData,
        timestamp: Date.now(),
        type: actions.GET_DELETE_ANNOUNCEMENT,
        spinnerId,
        spinnerType,
        callback
    };
}

export function getCourseAnnouncementsAction(
    coursePageClassId: string,
    coursePageActivityId: string,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    take?: number,
    skip?: number,
    callback?: any
): actionTypes.ICourseAnnouncementsAction {
    return {
        coursePageClassId,
        coursePageActivityId,
        timestamp: Date.now(),
        type: actions.GET_COURSE_ANNOUNCEMENT,
        spinnerId,
        spinnerType,
        take,
        skip,
        callback
    };
}

export function setCourseAnnouncementsAction(
    announcements: actionTypes.IAnnouncement[],
    announcementIsLoaded: boolean,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    stateId?: string,
    take?: number,
    skip?: number
): actionTypes.IAnnouncementsSetAction {
    return {
        stateId,
        announcementIsLoaded,
        announcements,
        timestamp: Date.now(),
        type: actions.SET_ANNOUNCEMENT_LIST,
        spinnerId,
        spinnerType,
        take,
        skip
    };
}

export function setUnreadAnnouncementCountAction(pageData: any, spinnerId: any): actionTypes.ISetUnreadAnnouncementCount {
    return {
        unreadAnnouncementCount: pageData.unreadAnnouncementCount,
        spinnerId,
        timestamp: Date.now(),
        type: actions.SET_UNREAD_ANNOUNCEMENT_COUNT
    };
}

export function GetReadAnnouncement(spinnerId?: string, spinnerType?: 'get' | 'set') : actionTypes.IGetReadAnnouncement {
    return{
        timestamp: Date.now(),
        type: actions.GET_READ_ANNOUNCEMENT,
        spinnerId,
        spinnerType
    };
}
